export default "__VITE_ASSET__BGa0gnMS__"